import {find, findIndex, map} from 'lodash';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';

import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import FullFluidWidthTemplate from 'components/Templates/FullFluidWidth';
import useModalService from 'components/shared/ModalService';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import UserForm from 'pages/admin/user/Form';
import UserList from 'pages/admin/user/List';

export default function UserPage() {
  const appContext = useAppContext();
  const modalService = useModalService();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const {response: techStackOptions, error: techStackOptionsErr} = useGet('api/v1/techStacks/list', {
    cacheResponse: false,
  }, {
    transform: (r) => map(r?.data?.techStacks, (val) => ({
      label: val?.techStackName,
      value: val?.techStackName,
      category: val?.category,
    })),
  });

  useEffect(() => {
    const abortController = new AbortController();
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/list', {
          parseJson: true,
        }, abortController);
        setData(rez?.data.users);
      } catch (err) {
        setError(err);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();

    return () => {
      abortController.abort();
    };

  }, []);

  const closeHandler = () => {
    modalService.close();
  };

  const saveHandler = (val) => {
    const userId = val?.data?.user?.userId;
    if (userId) {
      const existingIdx = findIndex(data, (u) => u.userId === userId);
      if (existingIdx >= 0) {
        const newUser = [...data];
        newUser.splice(existingIdx, 1, val?.data?.user);
        setData(newUser);
      } else {
        setData([val?.data?.user, ...data]);
      }
      toast.success(val?.message);
    }
    modalService.close();
  };


  const openEditEditor = async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    let id;
    let user;
    const closestAncestor = evt.target.closest('button[data-id]');
    if (closestAncestor && closestAncestor.getAttribute('data-id')) {
      id = closestAncestor.getAttribute('data-id');
      if (id) {
        user = find(data, (u) => u.userId === id);
        if (!user) {
          appContext.toastError(`Cannot find user ID ${id}!  Try reloading the page.`);
          return;
        }
      }
    }

    if (error) {
      setError(false);
    }

    modalService.open({
      closeHandler,
      style: {
        width: '40em',
      },
      content: (
        <UserForm
          techStackOptions={techStackOptions}
          user={user}
          onSave={saveHandler}
          onClose={closeHandler}
        />
      ),
    });
  };
  
  const allDataLoaded = techStackOptions && data;
  let body = <Loading />;
  if (error || techStackOptionsErr) {
    body = (
      <>
        <KyError kyError={error} />
        <KyError kyError={techStackOptionsErr} />
      </>
    );
  } else if (allDataLoaded) {
    body = (
      <UserList
        users={data}
        techStackOptions={techStackOptionsErr}
        onEdit={openEditEditor}
      />
    );
  }
  
  return (
    <FullFluidWidthTemplate title="All User Page">
      {body}
    </FullFluidWidthTemplate>
  );
}
